import './Login.scss';
import {loginByUserName} from '../../../api/auth';
import {useNavigate} from 'react-router-dom';
import {useState} from 'react';

const Login = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    async function performLogin(event) {
        event.preventDefault();
        setError(null);
        setLoading(true);

        return loginByUserName(username, password)
            .then(() => navigate('/dashboard'))
            .catch(() => setError('Invalid username or password.'))
            .finally(() => setLoading(false));
    }

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-card__heading">
                    <h1 className="login-card__title">Capital</h1>
                    <p className="login-card__subtitle">Sign in to your account</p>
                </div>

                <form className="login-form" onSubmit={performLogin}>
                    <div className="login-form__field">
                        <label className="login-form__label" htmlFor="login-username">Username</label>
                        <input
                            id="login-username"
                            className="login-form__input"
                            name="username"
                            autoComplete="username"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                        />
                    </div>

                    <div className="login-form__field">
                        <label className="login-form__label" htmlFor="login-password">Password</label>
                        <input
                            id="login-password"
                            className="login-form__input"
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </div>

                    {error && <p className="login-form__error">{error}</p>}

                    <button type="submit" className="login-form__submit" disabled={loading}>
                        {loading ? 'Signing in…' : 'Sign in'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;